module.exports = __webpack_public_path__ + "img/1111@2x.d689bfd5.png";